const LEAGUE_LABEL_KEY_BY_SLUG: Record<string, string> = {
  'premier-league': 'createRoom.leaguePremierLeague',
  PremierLeague: 'createRoom.leaguePremierLeague',
  'la-liga': 'createRoom.leagueLaLiga',
  laliga: 'createRoom.leagueLaLiga',
  LaLiga: 'createRoom.leagueLaLiga',
  bundesliga: 'createRoom.leagueBundesliga',
  BundesLiga: 'createRoom.leagueBundesliga',
  'serie-a': 'createRoom.leagueSerieA',
  SerieA: 'createRoom.leagueSerieA',
  'liga-1': 'createRoom.leagueLiga1',
  ligue1: 'createRoom.leagueLiga1',
  Liga1: 'createRoom.leagueLiga1',
  'champions-league': 'createRoom.leagueChampionsLeague',
  ChampionsLeague: 'createRoom.leagueChampionsLeague',
  WorldCup2026: 'createRoom.leagueWorldCup2026',
  worldcup2026: 'createRoom.leagueWorldCup2026',
}

export function getLeagueLabelKey(league: string): string {
  const slug = league.trim()
  if (LEAGUE_LABEL_KEY_BY_SLUG[slug]) {
    return LEAGUE_LABEL_KEY_BY_SLUG[slug]
  }

  const lower = slug.toLowerCase()
  for (const [key, value] of Object.entries(LEAGUE_LABEL_KEY_BY_SLUG)) {
    if (key.toLowerCase() === lower) {
      return value
    }
  }

  const parts = slug.split('-').map((s) => s.charAt(0).toUpperCase() + s.slice(1))
  return `createRoom.league${parts.join('')}`
}

export function getLeagueDisplayLabel(league: string, t: (key: string) => string): string {
  const key = getLeagueLabelKey(league)
  const label = t(key)
  return label && label !== key ? label : league
}
